module.exports = __webpack_public_path__ + "img/Logo_Yamaha_White-01-removebg-preview.156e8a37.png";